// API Service pour Good-Bloom
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || window.location.origin;
const API_BASE = `${BACKEND_URL}/api`;

console.log("🔍 API_BASE =", API_BASE); // debug utile en prod


class ApiService {
  // Generic HTTP methods
  async get(endpoint) {
    try {
      const response = await fetch(`${API_BASE}${endpoint}`);
      if (!response.ok) throw new Error(`Failed to fetch ${endpoint}`);
      return { data: await response.json() };
    } catch (error) {
      console.error(`Error fetching ${endpoint}:`, error);
      throw error;
    }
  }

  async post(endpoint, data) {
    try {
      const response = await fetch(`${API_BASE}${endpoint}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data)
      });
      
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || `Failed to post to ${endpoint}`);
      }
      
      return { data: await response.json() };
    } catch (error) {
      console.error(`Error posting to ${endpoint}:`, error);
      throw error;
    }
  }

  // Projects API
  async getProjects() {
    try {
      const response = await fetch(`${API_BASE}/projects/`);
      if (!response.ok) throw new Error('Failed to fetch projects');
      return await response.json();
    } catch (error) {
      console.error('Error fetching projects:', error);
      throw error;
    }
  }

  async getProject(id) {
    try {
      const response = await fetch(`${API_BASE}/projects/${id}`);
      if (!response.ok) throw new Error('Failed to fetch project');
      return await response.json();
    } catch (error) {
      console.error('Error fetching project:', error);
      throw error;
    }
  }

  // Contact API
  async submitContactForm(formData) {
    try {
      const response = await fetch(`${API_BASE}/contact/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });
      
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || 'Failed to submit contact form');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Error submitting contact form:', error);
      throw error;
    }
  }

  // Chat API
  async sendChatMessage(message, sessionId = null, clientType = null) {
    try {
      const requestData = { message };
      if (sessionId) requestData.session_id = sessionId;
      if (clientType) requestData.client_type = clientType;

      const response = await fetch(`${API_BASE}/chat/message`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestData)
      });
      
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || 'Failed to send chat message');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Error sending chat message:', error);
      throw error;
    }
  }

  async getChatSession(sessionId) {
    try {
      const response = await fetch(`${API_BASE}/chat/sessions/${sessionId}`);
      if (!response.ok) throw new Error('Failed to fetch chat session');
      return await response.json();
    } catch (error) {
      console.error('Error fetching chat session:', error);
      throw error;
    }
  }

  // Appointments API
  async qualifyAppointment(clientType, projectType = null, details = {}) {
    try {
      const requestData = {
        client_type: clientType,
        project_type: projectType,
        details
      };

      const response = await fetch(`${API_BASE}/appointments/qualify`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestData)
      });
      
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || 'Failed to qualify appointment');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Error qualifying appointment:', error);
      throw error;
    }
  }

  // Health check
  async healthCheck() {
    try {
      const response = await fetch(`${API_BASE}/health`);
      if (!response.ok) throw new Error('Health check failed');
      return await response.json();
    } catch (error) {
      console.error('Error in health check:', error);
      throw error;
    }
  }
}

// Créer une instance singleton
const api = new ApiService();

export default api;